import { AutoCompletionKind } from '../types';
import isSupportedLanguage from './isSupportedLanguage';
const mapMultiplexerRAutoCompletions = multiplexerAutocompletions => {
  if (Array.isArray(multiplexerAutocompletions.comps)) {
    return multiplexerAutocompletions.comps.map((inputCompletion, index) => {
      return {
        additionalDetail: "{".concat(multiplexerAutocompletions.packages[index], "}"),
        kind: AutoCompletionKind.Value,
        label: inputCompletion,
        textToInsert: inputCompletion
      };
    });
  }
  return [{
    additionalDetail: "{".concat(multiplexerAutocompletions.packages, "}"),
    kind: AutoCompletionKind.Value,
    label: multiplexerAutocompletions.comps,
    textToInsert: multiplexerAutocompletions.comps
  }];
};
const mapMultiplexerPythonAutoCompletions = multiplexerAutocompletions => {
  return multiplexerAutocompletions.map(inputCompletion => {
    if (typeof inputCompletion === 'string') {
      return {
        additionalDetail: 'keyword',
        kind: AutoCompletionKind.Value,
        label: inputCompletion,
        textToInsert: inputCompletion
      };
    }
    return {
      additionalDetail: inputCompletion.module,
      kind: AutoCompletionKind.Value,
      label: inputCompletion.completion,
      textToInsert: inputCompletion.completion
    };
  });
};
const mapMuxOutputToAutoCompletionItems = language => output => {
  if (!isSupportedLanguage(language)) {
    return [];
  }
  switch (language) {
    case 'python':
      {
        if (Array.isArray(output.payload)) {
          return mapMultiplexerPythonAutoCompletions(output.payload);
        }
        throw new Error('Unexpected autocompletion output format for language');
      }
    case 'r':
      {
        if (!Array.isArray(output.payload)) {
          return mapMultiplexerRAutoCompletions(output.payload);
        }
        throw new Error('Unexpected autocompletion output format for language');
      }
    default:
      {
        return [];
      }
  }
};
export default mapMuxOutputToAutoCompletionItems;